import { render, staticRenderFns } from "./HeaderGame.vue?vue&type=template&id=c137fc4c&scoped=true&"
import script from "./HeaderGame.vue?vue&type=script&lang=js&"
export * from "./HeaderGame.vue?vue&type=script&lang=js&"
import style0 from "./HeaderGame.vue?vue&type=style&index=0&id=c137fc4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c137fc4c",
  null
  
)

export default component.exports